import { useMemo } from "react";
import { todayContent } from "@/data/dailyElement";
import BookingButton from "./BookingButton";

const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function fmtDate(d) {
  const m = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return `${DOW[d.getDay()]}, ${m[d.getMonth()]} ${d.getDate()}`;
}

export default function TodaysElement() {
  const today = useMemo(() => todayContent(new Date()), []);
  const { season, nextSeason, daysUntilNextSeason, tea, point, mantra } = today;

  return (
    <section
      className="border-y"
      style={{ background: "var(--sano-bg-3)", borderColor: "var(--sano-border)" }}
      data-testid="todays-element"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4 flex flex-col">
          <div className="eyebrow mb-3" data-testid="todays-date">{fmtDate(new Date())}</div>
          <div className="flex items-center gap-3 mb-4">
            <span
              className="inline-block h-4 w-4 rounded-full"
              style={{ background: season.color, boxShadow: `0 0 0 6px ${season.color}22` }}
            />
            <span className="eyebrow" data-testid="todays-element-name">Today is {season.element} · {season.label}</span>
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight mb-3">
            Your <em className="italic">{season.element}</em> day.
          </h2>
          <p className="text-sm leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
            {season.organ} season. {daysUntilNextSeason} {daysUntilNextSeason === 1 ? "day" : "days"} until {nextSeason.element} ({nextSeason.label}).
          </p>
          <div className="mt-6">
            <BookingButton testid="todays-element-book" size="sm" label="Book a seasonal session" />
          </div>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-3 gap-px" style={{ background: "var(--sano-border)" }}>
          <Card label="Today's tea" value={tea} testid="todays-tea" />
          <Card label="Today's point" value={point.n} sub={point.how} testid="todays-point" />
          <Card label="Today's mantra" value={`“${mantra}”`} italic testid="todays-mantra" />
        </div>
      </div>
    </section>
  );
}

function Card({ label, value, sub, italic, testid }) {
  return (
    <div className="p-8" style={{ background: "var(--sano-bg)" }} data-testid={testid}>
      <div className="eyebrow mb-3">{label}</div>
      <div
        className={`font-serif-display text-2xl leading-tight ${italic ? "italic" : ""}`}
        style={{ color: "var(--sano-ink)" }}
      >
        {value}
      </div>
      {sub && (
        <div className="text-xs leading-relaxed mt-3" style={{ color: "var(--sano-ink-2)" }}>
          {sub}
        </div>
      )}
    </div>
  );
}
